<template>
    <div class="bg-[#23242A] text-white h-screen appheader overflow-y-auto p-3">
        <div class="p-3 flex content-main gap-5 pb-[70px]">

            <div class="custom-full">
                <Nav />


                <template v-if="can_manage_compliance_settings">

                    <template v-if="vg_selectedLocation.id">

                        <div class="bg-[#2B2C32] rounded-lg px-8 mt-1 pb-3">
                            <div class=" flex justify-between  h-[50px] items-center pt-2">
                                <h1 class="text-white font-semibold text-[24px]">Compliance</h1>
                                <button :disabled="!is_super_user" v-if="!loading" @click.prevent="!is_super_user ? void(0) : confirm()" :class="(!is_super_user ? 'bg-theme-grey text-slatewhite' : 'bg-white text-theme-green hover:bg-theme-darkgreen' ) + ' rounded  mt-2 px-4 py-2 '"><span
                                        class="text-sm tracking-widest font-medium">SAVE</span></button>
                            </div>

                            <block-loading v-if="loading"/>

                            <div class="flex gap-3 flex-col w-full items-start mb-3" v-else>

                                
                                <div class="w-full lg:w-2/4">
                                    <div :class="'input-wrapper ' + (form.providerName.error_type)">
                                        <label class="text-xs mb-1">Choose a Regulatory Body</label>
                                        <select :disabled="!is_super_user" @change="validateFields(['providerName'])" v-model="form.providerName.value" :class="'block rounded border-none w-full text-sm text-theme-white ' + (!is_super_user ? 'bg-theme-grey' : 'bg-gray-black')">
                                            <option value="">--Select--</option>
                                            <option value="ocs">OCS</option>
                                            <option value="aglc">AGLC</option>
                                            <option value="mbll">MBLL</option>
                                        </select>
                                        <p class="field-error label-text mt-1" v-if="form.providerName.error_message" v-text="form.providerName.error_message"></p>
                                    </div>
                                </div>

                                <div class="w-full lg:w-2/4">
                                    <div :class="'input-wrapper ' + (form.integrationSecret.error_type)">  
                                        <label class="text-xs mb-1 font-normal">Retailer Hash Key (to be confirmed)</label>
                                        <input :disabled="!is_super_user" @keyup="validateFields(['integrationSecret'])" v-model="form.integrationSecret.value" placeholder="[Key example]" type="text"
                                            :class="'block rounded border-none w-full text-sm text-theme-white ' + (!is_super_user ? 'bg-theme-grey' : 'bg-gray-black')">
                                            <p class="field-error label-text mt-1" v-if="form.integrationSecret.error_message" v-text="form.integrationSecret.error_message"></p>
                                    </div>
                                </div>
                                <div class="w-full lg:w-2/4">
                                    <div :class="'input-wrapper ' + (form.integrationKey.error_type)">
                                        <label class="text-xs mb-1 font-normal">CRSA</label>
                                        <input :disabled="!is_super_user" @keyup="validateFields(['integrationKey'])"  v-model="form.integrationKey.value" placeholder="Enter here" type="text"
                                            :class="'block rounded border-none w-full text-sm text-theme-white ' + (!is_super_user ? 'bg-theme-grey' : 'bg-gray-black')">
                                        <p class="field-error label-text mt-1" v-if="form.integrationKey.error_message" v-text="form.integrationKey.error_message"></p>
                                        <p class="text-theme-878686 text-xs mt-1">License number of your retailer</p>
                                    </div>
                                </div>

                                <div class="w-full lg:w-2/4">

                                    <div class="input-wrapper">
                                        <label class="block text-white text-xs mb-2" for="company">Enable Compliance</label>
                                        <div class="flex items-center cursor-pointer" @click.prevent="!is_super_user ? void(0) : form.complianceEnabled = !form.complianceEnabled" >
                                            <input type="checkbox" v-model="form.complianceEnabled" class="hidden peer">
                                            <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.complianceEnabled ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                                            <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.complianceEnabled ? 'text-theme-green' : 'text-[#F53333]'">{{form.complianceEnabled ? 'On' : 'Off'}}</span>
                                        </div>
                                    </div>

                                </div>
                                

                                

                                <div class="w-full lg:w-2/4">
                                    <!-- <p class="text-theme-878686 text-xs mt-2 mb-3">AGCO integration is automatically activated for your location.</p> -->
                                    <!-- <router-link :to="{ name: 'LocationInfo'}"
                                        class="mt-2 bg-theme-green uppercase text-white hover:bg-theme-darkgreen w-full rounded text-[14px] px-[20px] py-[8px]">Click
                                        here to change location info </router-link> -->

                                    <div v-if="!is_super_user" class="border-[1px] flex mt-[10px] bg-theme-orangefaded border-theme-orange rounded-[12px] text-white px-4 py-3 shadow-md" role="alert">
                                        <div class="flex">
                                            <div>
                                                <p class="font-semibold flex"> 
                                                    <svg width="20" height="20" class="mr-[10px]" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M9.325 11.175H10.825V4.85H9.325V11.175ZM10 15C10.2333 15 10.4292 14.9208 10.5875 14.7625C10.7458 14.6042 10.825 14.4083 10.825 14.175C10.825 13.9417 10.7458 13.7458 10.5875 13.5875C10.4292 13.4292 10.2333 13.35 10 13.35C9.76667 13.35 9.57083 13.4292 9.4125 13.5875C9.25417 13.7458 9.175 13.9417 9.175 14.175C9.175 14.4083 9.25417 14.6042 9.4125 14.7625C9.57083 14.9208 9.76667 15 10 15ZM10 20C8.58333 20 7.26667 19.7458 6.05 19.2375C4.83333 18.7292 3.775 18.025 2.875 17.125C1.975 16.225 1.27083 15.1667 0.7625 13.95C0.254167 12.7333 0 11.4167 0 10C0 8.6 0.254167 7.29167 0.7625 6.075C1.27083 4.85833 1.975 3.8 2.875 2.9C3.775 2 4.83333 1.29167 6.05 0.775C7.26667 0.258333 8.58333 0 10 0C11.4 0 12.7083 0.258333 13.925 0.775C15.1417 1.29167 16.2 2 17.1 2.9C18 3.8 18.7083 4.85833 19.225 6.075C19.7417 7.29167 20 8.6 20 10C20 11.4167 19.7417 12.7333 19.225 13.95C18.7083 15.1667 18 16.225 17.1 17.125C16.2 18.025 15.1417 18.7292 13.925 19.2375C12.7083 19.7458 11.4 20 10 20ZM10 18.5C12.3333 18.5 14.3333 17.6667 16 16C17.6667 14.3333 18.5 12.3333 18.5 10C18.5 7.66667 17.6667 5.66667 16 4C14.3333 2.33333 12.3333 1.5 10 1.5C7.66667 1.5 5.66667 2.33333 4 4C2.33333 5.66667 1.5 7.66667 1.5 10C1.5 12.3333 2.33333 14.3333 4 16C5.66667 17.6667 7.66667 18.5 10 18.5Z" fill="#FCB852"/>
                                                    </svg>
                                                    <span class="text-sm">You can't change your setting.</span>
                                                </p>
                                                <p class="text-sm mt-2">Once saved, this information cannot be updated without going through our support.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            
                            </div>


                        </div>

                    </template>

                    <div v-else class="bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5">
                        <p class="text-center text-theme-red mt-3">Please select a location from the top left corner.</p>
                    </div>

                </template>

                <div v-else class="bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5">
                    <p class="text-center text-theme-red mt-3">Page is restricted.</p>
                </div>

              

                
            </div>

        </div>



        <CustomDailogue v-if="confirmModal.modal" size="max-w-3xl">
           
            <template v-slot:maincontent>
       
                <div class="p-4 text-[14px] rounded-lg">
                    <div class="relative">
                        <h2 class="text-2xl text-white text-center pr-[40px]">Caution!</h2>
                        <span class="absolute right-1 top-1 pointer cursor-pointer hover:opacity-60"  @click.prevent="closeModal()">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.3333 2.54602L17.4533 0.666016L10 8.11935L2.54667 0.666016L0.666672 2.54602L8.12001 9.99935L0.666672 17.4527L2.54667 19.3327L10 11.8793L17.4533 19.3327L19.3333 17.4527L11.88 9.99935L19.3333 2.54602Z" fill="white"/>
                            </svg>
                        </span>
                    </div>
                
                    <div class="m-2 mt-4 tracking-wider grid-cols-4 bg-theme-modal_inner_bg rounded py-4 px-4 pb-4">
                        <div class="full justify-content-center">
                            
                            <div class="border-[1px] bg-theme-orangefaded border-theme-orange rounded-[12px] text-white px-4 py-3 shadow-md" role="alert">
                                <div class="flex">
                                
                                    <div>
                                        <p class="font-semibold flex"> 
                                            <svg width="20" height="20" class="mr-[10px]" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.325 11.175H10.825V4.85H9.325V11.175ZM10 15C10.2333 15 10.4292 14.9208 10.5875 14.7625C10.7458 14.6042 10.825 14.4083 10.825 14.175C10.825 13.9417 10.7458 13.7458 10.5875 13.5875C10.4292 13.4292 10.2333 13.35 10 13.35C9.76667 13.35 9.57083 13.4292 9.4125 13.5875C9.25417 13.7458 9.175 13.9417 9.175 14.175C9.175 14.4083 9.25417 14.6042 9.4125 14.7625C9.57083 14.9208 9.76667 15 10 15ZM10 20C8.58333 20 7.26667 19.7458 6.05 19.2375C4.83333 18.7292 3.775 18.025 2.875 17.125C1.975 16.225 1.27083 15.1667 0.7625 13.95C0.254167 12.7333 0 11.4167 0 10C0 8.6 0.254167 7.29167 0.7625 6.075C1.27083 4.85833 1.975 3.8 2.875 2.9C3.775 2 4.83333 1.29167 6.05 0.775C7.26667 0.258333 8.58333 0 10 0C11.4 0 12.7083 0.258333 13.925 0.775C15.1417 1.29167 16.2 2 17.1 2.9C18 3.8 18.7083 4.85833 19.225 6.075C19.7417 7.29167 20 8.6 20 10C20 11.4167 19.7417 12.7333 19.225 13.95C18.7083 15.1667 18 16.225 17.1 17.125C16.2 18.025 15.1417 18.7292 13.925 19.2375C12.7083 19.7458 11.4 20 10 20ZM10 18.5C12.3333 18.5 14.3333 17.6667 16 16C17.6667 14.3333 18.5 12.3333 18.5 10C18.5 7.66667 17.6667 5.66667 16 4C14.3333 2.33333 12.3333 1.5 10 1.5C7.66667 1.5 5.66667 2.33333 4 4C2.33333 5.66667 1.5 7.66667 1.5 10C1.5 12.3333 2.33333 14.3333 4 16C5.66667 17.6667 7.66667 18.5 10 18.5Z" fill="#FCB852"/>
                                            </svg>
                                            <span class="text-base">This is a final action that can’t be undone</span>
                                        </p>
                                        <p class="text-sm mt-2">Once saved, this information cannot be updated without going through our support.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="full flex">
                            <button @click.prevent="save()" class="text-base tracking-wide uppercase text-white bg-theme-green hover:bg-theme-darkgreen w-2/3 mt-6 border-0 rounded-md p-2 block mx-auto">CONFIRM TO PROCEED</button>
                        </div>
                    </div>
                    
                    <div class="mt-3 mb-1 text-center">
                        <button @click.prevent="closeModal()" class="text-white tracking-wide hover:text-theme-green text-center">CLOSE</button>
                    </div>
                </div>
                
            </template>
            
        </CustomDailogue>

    </div>
</template>


<script lang="ts">
    import {
        defineComponent,
        ref
    } from "vue"
    import {
        mapGetters,
        mapActions,
        mapMutations
    } from "vuex";
    import Nav from '@/views/Location/Integrations/Nav.vue';
    import CustomDailogue from "@/components/general/dialog/CustomDailogue.vue";
    import Helpers from '@/helpers';
    import LocationComplianceApis from '@/controllers/LocationComplianceApis';
    import { useSnackbar } from "vue3-snackbar";
    import router from '@/router';

    export default defineComponent({
        name: "LocationIntregationIndex",
        components: {
            Nav,
            CustomDailogue,
        },

        setup() {
            const confirmModal:any = ref({
                modal: false,
            });
            const loading = ref(false);
            const form:any = ref({
                complianceEnabled: false,
                providerName: {
                    value: '',
                    error_type: '',
                    error_message: '',
                    validations: ['required'],
                },
                integrationKey: {
                    value: '',
                    error_type: '',
                    error_message: '',
                    validations: ['required', 'max:15'],
                },
                integrationSecret: {
                    value: '',
                    error_type: '',
                    error_message: '',
                    validations: ['required'],
                },

            });
            const snackbar = useSnackbar();
            const hasSetting = ref(false);

            return {
                snackbar,
                hasSetting,
                form,
                loading,
                confirmModal,
            };
        },

        watch: {
            'vg_selectedLocation'(val) {
              if(this.vg_userToken){
                this.fetchData();
              }else{
                router.push('/login?sessionExpired=1')
              }
            },
        },

        computed: {
            ...mapGetters({
                vg_selectedLocation: 'location/selected',
                vg_userToken: 'auth/userToken',
                vg_user: 'auth/user',
            }),

            can_manage_compliance_settings() {
                return Helpers.getMyPermission('can_manage_compliance_settings');
            },
            is_super_user() {
                return Helpers.isSuperUser();
            },

        },

        mounted() {
            this.fetchData();
        },

        beforeDestroy() {

        },

        methods: {

             /**
             * Validation captures
             */
            async validateFields(fields) {
                let res = await Helpers.validateFormFields(this.form, fields);
                // capture the fields
                this.form = res.data;
                return res.error ? false : true;
            },
            
            /**
             * Save data
             */
             async fetchData() {
                this.loading = true;
                let res = await LocationComplianceApis.fetch();
                if(res.status == 200) {
                    this.hasSetting = true;
                    this.form = Helpers.assignFormValues(this.form, res.data.payload);
                } else {
                    this.hasSetting = false;
                    this.form = Helpers.resetFormValue(this.form)
                    this.form.complianceEnabled = false;
                }
                this.loading = false;
            },

            /**
             * Save data
             */
            async save() {
                this.va_spinner(true);
                let res = await LocationComplianceApis.create(Helpers.getFormKeyValue(this.form));
                this.va_spinner(false);
                if(res.status == 201){
                    this.hasSetting = true;
                }
                this.snackbar.add({
                    type: 'info',
                    text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })
                this.closeModal();
            },

            /**
             * validate and show return confirm modal
             */
            async confirm() {
                let validate = await this.validateFields(['providerName', 'integrationKey', 'integrationSecret']);
                if(!validate) {
                    return ;
                }
                
                this.confirmModal.modal = true;
            },

            /**
             * Close return confirm modal
             */

            closeModal() {
                this.confirmModal.modal = false;
            },

            preventNonNumbersAndDecimal(e) {
                var ASCIICode = (e.which) ? e.which : e.keyCode
                if (ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 101 || e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
                    return false;
                }
                return true;
            },

            ...mapActions({
                va_spinner: 'spinner/setSpinner',
            })
        },
    });
</script>